import {dsColorNew} from "@palette";


const overrideTableStyles = () => ({
    // --- MUI Data Table (mui-datatables) ---
    MUIDataTable: {
        styleOverrides: {
            paper: {
                boxShadow: 'none',
                border: `1px solid ${dsColorNew.grayBorder}`,
                borderRadius: 12,
            },
            responsiveBase: {
                borderRadius: 0,
            }
        }
    },
    MUIDataTableHeadCell: {
        styleOverrides: {
            root: {
                backgroundColor: dsColorNew.filterInputBg,
                color: '#6B7280',
                fontWeight: 600,
                fontSize: '0.75rem',
                borderBottom: `1px solid ${dsColorNew.grayBorder}`,
                padding: '10px 16px',
                whiteSpace: 'normal',
            },
            toolButton: {
                fontWeight: 600,
                fontSize: '0.75rem',
                color: '#6B7280',
            },
            sortAction: {
                alignItems: 'center',
                '& svg': {
                    fontSize: '1rem',
                    color: '#9CA3AF',
                },
            },
        }
    },
    MUIDataTableBodyCell: {
        styleOverrides: {
            root: {
                fontSize: '0.8125rem',
                color: '#111827',
                borderBottom: 'none',
                borderRight: 'none',
                padding: '16px 16px',
            },
            stackedCommon: {
                borderBottom: 'none',
            },
        }
    },
    MuiTableCell: {
        styleOverrides: {
            body: {
                borderRight: 'none',
                borderBottom: 'none',
            }
        }
    },
    MUIDataTableBodyRow: {
        styleOverrides: {
            root: {
                borderBottom: `1px solid #F3F4F6`,
                '&:hover td': {
                    backgroundColor: dsColorNew.hoverBgLight,
                },
            }
        }
    },
    MUIDataTableToolbar: {
        styleOverrides: {
            root: {
                padding: '12px 16px',
                minHeight: 52,
                borderBottom: `1px solid ${dsColorNew.grayBorder}`,
                '& svg': {
                    fontSize: '1.25rem',
                    color: '#6B7280',
                },
            },
            titleText: {
                fontSize: '0.875rem',
                fontWeight: 600,
                color: '#111827',
            },
        }
    },
    MUIDataTablePagination: {
        styleOverrides: {
            root: {
                borderTop: `1px solid ${dsColorNew.grayBorder}`,
            }
        }
    },
    MuiTablePagination: {
        styleOverrides: {
            toolbar: {
                minHeight: 48,
                paddingLeft: 16,
                paddingRight: 8,
            },
            selectLabel: {
                color: dsColorNew.textDark,
                fontSize: '0.75rem',
            },
            displayedRows: {
                color: dsColorNew.textDark,
                fontSize: '0.75rem',
            },
            select: {
                fontSize: '0.75rem',
                color: dsColorNew.textDark,
            },
            actions: {
                '& .MuiIconButton-root': {
                    padding: 6,
                    border: `1px solid ${dsColorNew.grayBorder}`,
                    borderRadius: 6,
                    marginLeft: 8,
                    '& svg': {
                        fontSize: '1.125rem',
                        color: '#6B7280',
                    },
                    '&:hover': {
                        backgroundColor: dsColorNew.hoverBgLight,
                    },
                    '&.Mui-disabled': {
                        border: `1px solid #F3F4F6`,
                        '& svg': { color: '#D1D5DB' },
                    },
                },
            },
        }
    },
})

export default overrideTableStyles
